import { Card, Typography } from "antd";
import "./MissionCard.scss";

const { Title, Text } = Typography;

export default function MissionCard({ token }) {
  return (
    <Card
      className="aboutMission-card"
      hoverable
      style={{
        border: "none",
        backgroundColor: token?.Card?.colorBgCard,
        borderLeft: `4px solid ${token?.colorPrimary}`,
      }}>
      <div className="aboutMission-card__content">
        <Title level={3} style={{ color: token?.colorPrimary, margin: 0 }}>
          Our Mission
        </Title>
        <Text className="aboutMission-card__text">
          BlackList420 is a comprehensive platform designed to empower
          healthcare organizations with secure and efficient patient record
          management. We provide real-time access to patient information,
          enabling healthcare professionals to make informed decisions quickly
          and confidently.
        </Text>
        <Text className="aboutMission-card__text">
          Our platform connects healthcare providers with essential patient
          data, streamlining workflows and enhancing care coordination. With
          robust search capabilities and real-time updates, you'll always have
          the information you need at your fingertips.
        </Text>
      </div>
    </Card>
  );
}
